import { Injectable } from '@angular/core';
import { RelatorioRequisicao } from 'src/app/relatorio/modelos/relatorio-requisicao';
import { UrlService } from '../url.service';

@Injectable({
  providedIn: 'root'
})
export class HistoriaClinicaRelatorioService {

  constructor(private url: UrlService) { }

  requisicarHistoriaClinica(pessoaId: number): RelatorioRequisicao<Object> {
    return {
      consulta: { pessoaId: pessoaId },
      url: this.url.url(`relatorios/historias-clinicas`)
    }
  }
}
